import axios from "axios";
import { GoogleAuthLinkApi, GoogleAuthCodeApi } from ".";

export const getGoogleAuthLink = () => {
  return axios
    .get(`${GoogleAuthLinkApi}`)
    .then((res) => {
      return res?.data;
    })
    .catch(() => {});
};

export const fetchDataFromGoogleAuthCode = ({ code }) => {
  return axios
    .get(`${GoogleAuthCodeApi}`, { params: { code: code } })
    .then((res) => {
      return res?.data;
    })
    .catch((error) => {
      if (error?.response?.status == 400) {
        return {
          token: false,
        };
      } else {
        return null;
      }
    });
};
